/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import { END } from 'redux-saga';
import {
    take, fork, call, put, select, takeLatest,
} from 'redux-saga/effects';
// TODO remove in the future, now still doing testing. CO-1456
// import Cookies from 'universal-cookie';
import Cookies from 'universal-cookie';
import mbpLogger from 'mbp-logger';

import mbpUtil from 'mbp-api-util';
import * as commonSelectors from '../Common/Common-Selectors';
import {
    getOrderStatus,
    getRecipients,
    getIsPassportOnlyItemOnCart,
    getIsDonationOnlyItemOnCart,
    getOrderId,
} from '../../../MfeCheckout/ducks/Cart/Cart-Selectors';
import { errorActions, errorOperations } from '../../../Common/ducks/Error';
import * as retryCalculateShippingActions from '../Recipient/ducks/RetryCalculateShipping/RetryCalculateShipping-Actions';
import { showLoadingMessageActions } from '../../../Common/ducks/ShowLoadingMessage';
import { activePaymentMethod, inActivePaymentMethod } from '../Payment/Payment-Actions';
import { retrieveCart } from '../../../MfeCheckout/ducks/Cart/ducks/RetrieveCart/RetrieveCart-Operations';
import { getBrand } from '../../../App/ducks/Config/Config-Selectors';

import {
    calculateCart,
    calculateCartComplete,
    saveBannerToOrder,
    saveBannerProcessCheckCompleted,
    checkApplePayEnabled,
    validateShopCart,
    handleAddExtraItem,
} from './Checkout-Actions';

import { callHandleCartFailure, loadCart } from '../../../MfeCheckout/ducks/Cart/Cart-Actions';
import cartServiceClient from '../../../../../apis/cart-service-apis/cartServiceClient';
import { checkJWT } from '../Global/Global-Operations';
import { addAddonsToCart, addToCartFailed } from '../AddToCart/AddToCart-Actions';
import { getAddressSource } from '../../../App/App-Selectors';
import { getFeatureFlags } from '../../../MfeCheckout/ducks/App/App-Selectors';
import { cartStatusCompleteList } from '../../../../../app/helpers/common/helper';

function* onLoadOrderDetails() {
    try {
        yield call(retrieveCart);
    } catch (ex) {
        mbpLogger.logError({
            appName: process.env.npm_package_name,
            module: 'Checkout-Operations',
            function: 'onLoadOrderDetails',
            jsError: ex,
            message: 'Failed to load order details',
        });
    }
}

export function* workerCalculateCart() {
    function* handleCalcShippingFailure(err) {
        // Clear Error
        yield put(errorActions.clearErrors({
            errType: 'payment',
            field: 'error',
        }));

        // Retry Calculate Shipping
        // Commented out retry calcualte shipping code to check the impact of calculate shipping API calls
        /*
        const noOfAttempt = yield select(commonSelectors.getCalShippingAttempt);
        if (noOfAttempt < 1) {
            yield put(retryCalculateShippingActions.updateRetryCalculateShippingAttempt());
            yield call(calcShipping);
        } else {
            // Retry Calcualte Shipping Fails
            // Get Cart
            yield call(retrieveCart, 'payment');
            yield put(retryCalculateShippingActions.updateCalculateShippingApplied(false));

            // Log Error only if error status is 401, 403, 404, 500, 501, 503
            const arrErrorCodes = [401, 403, 404, 500, 501, 503];
            const errCode = err?.response?.status;

            if (errCode && arrErrorCodes.includes(errCode)) {
                yield put(showLoadingMessageActions.flagOffShowLoadingMessage());
                yield call(errorOperations.getError, err, 'payment');
            }
        }
        */

        // Get Cart
        yield call(retrieveCart, 'payment');
        yield put(retryCalculateShippingActions.updateCalculateShippingApplied(false));

        // Log Error only if error status is 401, 403, 404, 500, 501, 503, 504
        const errCode = err?.response?.status;
        if (errCode && errorOperations.arrErrorCodes.includes(errCode)) {
            yield put(showLoadingMessageActions.flagOffShowLoadingMessage());
            yield call(errorOperations.getError, err, 'payment');
        }
    }

    const logOrderId = yield select(commonSelectors.getOrderId);

    try {
        // yield put(showLoadingMessageActions.updateShowLoadingMessage());
        const cartId = yield select(commonSelectors.getOrderId);

        if (cartId) {
            const jwtToken = yield call(checkJWT);
            const flagState = yield select(getFeatureFlags);

            // Calculate Estimate Shipping
            const isShippingEstimated = flagState['is-estimated-shipping-enabled'] || false;
            const siteExpirement = flagState['site-experiment-mode'] || {};

            let calEstimatedShippping = 'false';
            if (isShippingEstimated) {
                calEstimatedShippping = 'true';
            }

            mbpLogger.logDebug({
                appName: process.env.npm_package_name,
                module: 'Checkout-Operations',
                function: 'workerCalculateCart',
                message: 'Call - Calculate Shipping API',
                orderId: logOrderId,
            });

            // Call Calculate Shipping API
            const headers = {};

            if (siteExpirement.value) {
                headers.sv = siteExpirement.value;
            }

            const payload = {
                env: {},
                jwtToken,
                cartId,
                calEstimatedShippping,
                headers,
            };

            // Call Calculate Shipping API
            const calculatOrd = yield call(cartServiceClient.calculateCart, payload);

            mbpLogger.logDebug({
                appName: process.env.npm_package_name,
                module: 'Checkout-Operations',
                function: 'workerCalculateCart',
                message: 'Response - Calculate Shipping API',
                orderId: logOrderId,
            });

            const { successFlag, result } = calculatOrd.data;
            if (successFlag === true || successFlag === 'true' || result === 'SUCCESS') {
                yield put(errorActions.clearErrors({
                    errType: 'payment',
                    field: 'error',
                }));
            }
        } else {
            const windowLocation = (typeof window !== 'undefined') ? window.location.href : '';
            mbpLogger.logError({
                appName: process.env.npm_package_name,
                module: 'Checkout-Operations.js',
                function: 'workerCalculateCart',
                message: 'Calculate Cart - No OrderId',
                orderId: logOrderId,
                windowLocation,
            });
        }
    } catch (exp) {
        yield put(callHandleCartFailure(exp));

        mbpLogger.logError({
            appName: process.env.npm_package_name,
            module: 'Checkout-Operations',
            function: 'workerCalculateCart',
            jsError: exp,
            message: 'Error occured while calculating order',
            orderId: logOrderId,
        });
        yield call(handleCalcShippingFailure, exp);
    }
    yield put(calculateCartComplete());
}

function* checkoutRouteHandler(history) {
    try {
        const allOrderItems = yield select(getRecipients);
        const isPassportOnlyItem = yield select(getIsPassportOnlyItemOnCart);
        const isDonationOnlyItem = yield select(getIsDonationOnlyItemOnCart);
        const orderId = yield select(commonSelectors.getOrderId);
        const pagePath = history.location.pathname;
        const orderStatus = yield select(getOrderStatus);

        if (orderStatus && cartStatusCompleteList.includes(orderStatus)) {
            history.push(`/checkout/order-confirmation/${orderId}`);
        } else if (pagePath.indexOf('/shipping') > 0) {
            // IF Passport only item in cart proceed to payment page
            if (isPassportOnlyItem || isDonationOnlyItem) {
                history.push(`/checkout/payment/${orderId}`);
            } else if (allOrderItems.length === 0) {
                history.push(`/checkout/cart/${orderId}`);
            }
        } else if (pagePath.indexOf('/payment') > 0) {
            if (allOrderItems.length === 0) {
                history.push(`/checkout/cart/${orderId}`);
            }
        } else if (pagePath.indexOf('/review-order') > 0) {
            const placeOrderStatus = yield select(commonSelectors.getPlaceOrderStatus);
            const selectedPaymentMethod = yield select(commonSelectors.getPaymentMethod);
            const paymentForm = yield select(commonSelectors.getPaymentInfo);

            if (selectedPaymentMethod.id === 'CreditCard' && !paymentForm.nameOnCreditCard && !placeOrderStatus && allOrderItems.length > 0) {
                history.push(`/checkout/payment/${orderId}`);
            } else if (allOrderItems.length === 0) {
                history.push(`/checkout/cart/${orderId}`);
            }
        } else if (pagePath.indexOf('/cart') < 0) {
            history.push(`/checkout/cart/${orderId}`);
        }
    } catch (ex) {
        const orderId = yield select(commonSelectors.getOrderId);
        mbpLogger.logError({
            appName: process.env.npm_package_name,
            module: 'mbp-pwa-ui',
            function: 'checkoutRouteHandler',
            jsError: ex,
            message: 'Error occured while handling checkout route',
            orderId,
        });
    }
}

function* processValidateShopCart(action) {
    const {
        orderId,
        history,
    } = action.data;
    // api for ValidateShopCart
    // const JWT_TOKEN = yield call(checkJWT);
    // yield call(postValidateShopCart, {
    //     JWT_TOKEN,
    //     orderId,
    // });
    yield call(history.push, `/checkout/shipping/${orderId}`);
}

// TODO remove in the future, now still doing testing. CO-1456
// function removeBannerCookie() {
//     const cookies = new Cookies();
//     cookies.remove('banner', { path: '/' });
// }

export function* onPersistAttribution({ bannerCode, lsid }) {
    const featureFlags = yield select(getFeatureFlags);
    const orderId = yield select(getOrderId);

    try {
        const cookies = new Cookies();
        const jwtToken = yield call(checkJWT);

        const addressSource = yield select(getAddressSource);
        let sourceValue = '';
        if (addressSource === 'smg') {
            sourceValue = 'smg';
        }

        const payload = {
            orderId: `${orderId}`,
            lsId: `${lsid}`,
        };

        const attributes = [];
        if (sourceValue && featureFlags['is-source-attribute-used-in-checkout']) {
            attributes.push(
                {
                    attributeName: 'source',
                    attributeValue: sourceValue,
                },
            );
        }

        if (attributes.length) {
            payload.attributes = attributes;
        }

        if (featureFlags['is-checkout-monitoring-enabled']) {
            console.error({
                function: 'onPersistAttribution',
                bannerCode,
                attributes,
                payload,
                bannerCookie: (cookies.get('banner')) ? cookies.get('banner') : '',
                addressSource,
                message: `Persisting banner payload ${orderId}`,
            });

            mbpLogger.logInfo({
                appName: process.env.npm_package_name,
                module: 'Checkout-Operations.js',
                function: 'onPersistAttribution',
                errorMessage: {
                    bannerCode,
                    attributes,
                    addressSource,
                },
                message: `Persisting banner attributes ${orderId} - Before call API`,
            });

            mbpLogger.logInfo({
                appName: process.env.npm_package_name,
                module: 'Checkout-Operations.js',
                function: 'onPersistAttribution',
                errorMessage: (cookies.get('banner')) ? cookies.get('banner') : '',
                message: `Persisting banner cookie ${orderId} - Before call API`,
            });

            mbpLogger.logInfo({
                appName: process.env.npm_package_name,
                module: 'Checkout-Operations.js',
                function: 'onPersistAttribution',
                errorMessage: payload,
                message: `Persisting banner payload ${orderId} - Before call API`,
            });
        }

        const persisAttrResp = yield call(cartServiceClient.recordAttributions, {
            jwtToken,
            cartId: orderId,
            bannerCode,
            attributes,
        });
        if (persisAttrResp.data) {
            if (featureFlags['is-checkout-monitoring-enabled']) {
                console.log({
                    appName: process.env.npm_package_name,
                    module: 'Checkout-Operations.js',
                    function: 'onPersistAttribution',
                    errorMessage: persisAttrResp,
                    message: `Persisting banner response API - ${orderId}`,
                });
            }
            yield put(saveBannerProcessCheckCompleted());
        }
    } catch (ex) {
        console.log('Debug - error onPersistAttribution Error', ex);
        console.log('Debug - error onPersistAttribution Response', ex?.response);
        if (featureFlags['is-checkout-monitoring-enabled']) {
            console.error({
                appName: process.env.npm_package_name,
                module: 'Checkout-Operations.js',
                function: 'onPersistAttribution',
                errorMessage: ex.response,
                message: 'Error response in pesisting banner',
            });
        }

        mbpLogger.logInfo({
            appName: process.env.npm_package_name,
            module: 'Checkout-Operations',
            function: 'onPersistAttribution',
            jsError: ex,
            errorMessage: ex.response,
            message: `Error occured while persisting banner information - ${orderId}`,
        });

        yield put(callHandleCartFailure(ex));
        yield put(saveBannerProcessCheckCompleted());
    }
}

const checkApplePayAvailable = (merchantIdentifier) => new Promise((resolve) => {
    const promise = window.ApplePaySession.canMakePaymentsWithActiveCard(merchantIdentifier);
    promise.then(resolve).catch(() => resolve(false));
});

function* workerApplePayAvailable() {
    mbpLogger.logDebug({
        appName: process.env.npm_package_name,
        module: 'Checkout-Operations',
        function: 'workerApplePayAvailable',
        message: 'initiate apple pay availability check',
    });
    try {
        const brand = yield select(getBrand);
        const merchantIdentifier = mbpUtil.getEnv('APP_APPLE_PAY_MID') || `${brand['apple-pay-merchant-id']}`;
        const applePayEnabled = yield call(
            checkApplePayAvailable,
            merchantIdentifier,
        );
        if (applePayEnabled) {
            yield put(activePaymentMethod('ApplePay'));
        } else {
            yield put(inActivePaymentMethod('ApplePay'));
        }
    } catch (ex) {
        yield put(inActivePaymentMethod('ApplePay'));
        mbpLogger.logError({
            function: 'workerApplePayAvailable',
            appName: process.env.npm_package_name,
            module: 'Checkout-Operations',
            jsError: ex,
            message: 'workerApplePayAvailable failed',
        });
    }
}

function* watchCalculateCart() {
    yield takeLatest(calculateCart().type, workerCalculateCart);
}

function* watchPersistAttribution() {
    let action = yield take(saveBannerToOrder().type);
    while (action !== END) {
        yield fork(onPersistAttribution, action.payload);
        action = yield take(saveBannerToOrder().type);
    }
}

function* watchCheckApplePayAvailability() {
    yield takeLatest(checkApplePayEnabled().type, workerApplePayAvailable);
}

function* watcherValidateShopCart() {
    yield takeLatest(validateShopCart().type, processValidateShopCart);
}

function* workerHandleAddExtraItemToCart(action) {
    const {
        extraItemData,
        orderItemId,
        selectedItems,
        handleClose,
    } = action.data;

    yield put(addAddonsToCart(extraItemData, null, orderItemId, null, selectedItems));

    const response = yield take([loadCart().type, addToCartFailed().type]);

    if (response.type === loadCart().type) {
        handleClose();
    }
}

function* watcherHandleAddExtraItemToCart() {
    yield takeLatest(handleAddExtraItem().type, workerHandleAddExtraItemToCart);
}

const watchers = [
    fork(watchCalculateCart),
    fork(watchPersistAttribution),
    fork(watchCheckApplePayAvailability),
    fork(watcherValidateShopCart),
    fork(watcherHandleAddExtraItemToCart),
];

export {
    watchers,
    onLoadOrderDetails,
    checkoutRouteHandler,
};

export default {};
